interface WebsiteStore {
    advertisement: { src: string; alt: string; link: string; name: string; descript: string }[];
    advertisementCRO: { src: string; alt: string; link: string; name: string; descript: string }[];
    friendlyLink: { name: string; link: string }[];
    agent: "web" | "mobile";
    view: string;
}

interface WebsiteUpdateStore {
    advertisement?: { src: string; alt: string; link: string; name: string; descript: string }[];
    advertisementCRO?: { src: string; alt: string; link: string; name: string; descript: string }[];
    friendlyLink?: { name: string; link: string }[];
    agent?: string;
    view?: string;
}

export const useWebsiteStore = defineStore("website", {
    state: (): WebsiteStore => {
        return {
            advertisement: [], //* 顶部活动
            advertisementCRO: [], //* 顶部活动CRO
            friendlyLink: [], //* 友情链接
            agent: "web",
            view: "default",
        };
    },

    actions: {
        updated: function (data?: WebsiteUpdateStore) {
            this.view = data?.view || this.view || "default";
            this.friendlyLink = data?.friendlyLink || this.friendlyLink || [];
            this.advertisement = data?.advertisement || this.advertisement || [];
            this.advertisementCRO = data?.advertisementCRO || this.advertisementCRO || [];
            if (data?.agent) {
                if (data?.agent == "web" || data?.agent == "mobile") this.agent = data.agent;
                else {
                    this.agent = "web";
                }
            }
        },
    },
});
